import { createReducer, on } from '@ngrx/store';

import {
  fetchFiltersSuccessAction,
} from '@flight-results/store/actions/flights-results.actions';
import { FlightWidgetsMobile } from '@app/entities/flight-results-widget';
import { 
  searchAirlinesByLowerPrice,
  mapPriceForWidget,
  mapDepartureForWidget,
  mapFlightDurationForWidget
} from '@flight-results/mappers/flights-widgets.mapper';
import { SectorTypes } from '@shared/flight-itinerary/entities/filters';

export const initialFlightWidgets: FlightWidgetsMobile = {} as FlightWidgetsMobile;

export const flightResultsWidgetsReducer = createReducer(
  initialFlightWidgets,
  on(fetchFiltersSuccessAction, (state, { filters }) => {
    return {
      ...state,
      Airlines: searchAirlinesByLowerPrice(filters.Airlines),
      PriceWidget: mapPriceForWidget(filters.MinPrice, filters.MaxPrice),
      HourWidget: mapDepartureForWidget(filters.DepartureTimes, SectorTypes.Sector1),
      HourWidgetReturn: mapDepartureForWidget(filters.DepartureTimes, SectorTypes.Sector2),
      FlightDurationWidget: mapFlightDurationForWidget(filters.FlightDurations, 0),
      FlightDurationWidgetReturn: mapFlightDurationForWidget(filters.FlightDurations, 0)
    }; 
  }),
);
